import ChatItem from '@SonarCX/components/organisms/TaskMultiEdit/Share/ChatItem'
import ModalInput from '../ModalInput'
import useStyles from './styles'

const ShareTask = ({
  search,
  setSearch,
  filtered,
  sessions,
  updateSelected,
  message,
  setMessage
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <ModalInput
        placeholder='Search for team chat'
        value={search}
        onChange={e => setSearch(e.target.value)}
        className={classes.input}
      />

      <div className={classes.results}>
        {filtered.length === 0 && (
          <div className={classes.noResults}>No team chats found</div>
        )}

        {filtered.map(dm => {
          const id = dm.session
          const isSelected = sessions.includes(id)

          return (
            <ChatItem
              key={dm.session}
              dm={dm}
              isSelected={isSelected}
              toggleSelected={() => updateSelected(id, isSelected)}
            />
          )
        })}
      </div>

      <ModalInput
        placeholder='Enter message (optional)'
        value={message}
        onChange={e => setMessage(e.target.value)}
        className={classes.input}
      />
    </div>
  )
}
export default ShareTask
